import gql from 'graphql-tag'

export default gql`
mutation ($subject: MongoID  ){
        removeStudentOfSubjects(filter:{ subject: $subject}){
        numAffected
      }
}
`